import React, { useState, useEffect, useCallback } from 'react';
import { FaCalendarAlt, FaClock, FaUser, FaCheck, FaTimes, FaPlus, FaTrash, FaVideo, FaMapMarkerAlt, FaPhone, FaChevronLeft, FaChevronRight, FaExclamationTriangle, FaSearch, FaFilter, FaSort, FaEllipsisV, FaUserCircle, FaEdit, FaStar, FaArrowRight, FaCheckCircle, FaRedoAlt, FaArrowLeft, FaInfoCircle, FaSortAmountUp, FaSortAmountDown, FaLink, FaList, FaCalendarPlus, FaCalendarMinus, FaCalendarDay, FaFileExcel } from 'react-icons/fa';
import { Modal, Button, Form, Badge, Card, Dropdown, Row, Col, Alert } from 'react-bootstrap';
import moment from 'moment';
import 'moment/locale/fr';
import Sidebar from '../dashboard/sidebar';
import Navbar from '../dashboard/navbar';
import useAuth from '../dashboard/useAuth';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import CustomCalendar from './calendrier';
import { getAuthToken } from '../../authToken';

const GestionRendezVousAdmin = () => {
  useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const user_id = localStorage.getItem('user_id');
  const [currentMonth, setCurrentMonth] = useState(moment());
  const [selectedDate, setSelectedDate] = useState(moment());
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [availableBookings, setAvailableBookings] = useState([]);
  const [isLoadingListeBooking, setIsLoadingListeBooking] = useState(false);

  // États pour les réservations
  const [reservations, setReservations] = useState([]);
  const [isLoadingReservations, setIsLoadingReservations] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showStatutModal, setShowStatutModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [selectedReservation, setSelectedReservation] = useState(null);
  const [annulationMotif, setAnnulationMotif] = useState('');
  const [creneauxFilter, setCreneauxFilter] = useState('all');
  const [availableCreneaux, setAvailableCreneaux] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);

  const [showExportModal, setShowExportModal] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(moment().format('YYYY-MM'));
  const [isExporting, setIsExporting] = useState(false);

  useEffect(() => {
    if (user_id) {
      document.title = "eTrainApp | Booking";
    }
  }, [user_id]);

  const fetchBookings = async () => {
    setIsLoadingListeBooking(true);
    try {
      const token = localStorage.getItem('access_token');

      const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-bookings/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
      });
      // const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-bookings/`);

      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des données');
      }

      const data = await response.json();

      if (data.status === 'success') {
        const transformedBookings = data.bookings.map(booking => ({
          id: booking?.id,
          title: booking?.titre,
          type: booking?.type_booking,
          lieu: booking?.lieu,
          statut: booking?.statut,
          description: booking?.description,
          color: booking?.couleur,
          nb_participants: booking?.nb_participants,
          nbre_heure: booking?.nbre_heure,
          nb_place_total: booking?.nb_place_total,
          heure_deb: booking?.heure_deb || '09:00',
          heure_fin: booking?.heure_fin || '10:00',
          type_crenau: booking?.type_crenau || 'en_ligne',
          reservations: booking?.reservations || [],
          lien_teams: booking?.lien_teams || '',
          nom_coach: booking?.nom_coach || '',
          nombre_reservations: booking?.nombre_reservations || 0,
          date_booking: booking?.date_booking
        }));

        setAvailableBookings(transformedBookings);
      } else {
        throw new Error(data.message || 'Erreur inconnue');
      }

    } catch (error) {
      console.error('Erreur:', error);
      showAlert(`Erreur de chargement: ${error.message}`, 'danger');
    } finally {
      setIsLoadingListeBooking(false);
    }
  };

  useEffect(() => {
    if (user_id) {
      fetchBookings();
    }
  }, [user_id]);

  const [nouveauBooking, setNouveauBooking] = useState({
    titre: '',
    type_booking: '',
    dates_booking: [], // REMPLACER date_booking par dates_booking
    description: '',
    couleur: '#6366f1',
    heure_deb: '09:00',
    heure_fin: '10:00',
    type_crenau: 'en_ligne',
    lien_teams: '',
    lieu: '',
    nb_participants: 1
  });

  const [alert, setAlert] = useState({ message: '', type: '' });
  const [alertModal, setAlertModal] = useState({ message: '', type: '' });
  const [isChargement, setIsChargement] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [bookingToDelete, setBookingToDelete] = useState(null);

  const showAlert = (message, type = 'primary') => {
    setAlert({ message, type });
  };

  const showAlertModal = (message, type = 'primary') => {
    setAlertModal({ message, type });
  };

  const fermerNotif = () => {
    setAlert({ message: '', type: '' });
    setAlertModal({ message: '', type: '' });
  };

  useEffect(() => {
    if (availableBookings.length > 0 && !selectedBooking) {
      setSelectedBooking(availableBookings[0]);
    }
  }, [availableBookings]);


  const handleExportBilan = async () => {
    try {
      setIsExporting(true);

      const token = localStorage.getItem('access_token');

      const response = await fetch(
        `${process.env.REACT_APP_HOTE}/exporter-bilan-coaching/?mois=${selectedMonth}`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Erreur lors de l\'export');
      }

      // Récupérer le blob du fichier
      const blob = await response.blob();

      // Créer un lien de téléchargement
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `bilan_coaching_${selectedMonth}.xlsx`;
      document.body.appendChild(a);
      a.click();

      // Nettoyer
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      showAlert('Export réussi !', 'success');
      setShowExportModal(false);

    } catch (error) {
      console.error('Erreur export:', error);
      showAlert(error.message || 'Erreur lors de l\'export', 'danger');
    } finally {
      setIsExporting(false);
    }
  };




  const [showAssignCoachModal, setShowAssignCoachModal] = useState(false);
  const [selectedBookingForCoach, setSelectedBookingForCoach] = useState(null);
  const [utilisateurs, setUtilisateurs] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchUserTerm, setSearchUserTerm] = useState('');
  const [isLoadingUsers, setIsLoadingUsers] = useState(false);

  // Fonction pour récupérer la liste des utilisateurs
  const fetchUtilisateurs = async () => {
    setIsLoadingUsers(true);
    try {

      const token = localStorage.getItem('access_token');

      // Envoi au backend
      const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-utilisateurs-complet/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
      });

      if (!response.ok) {
        throw new Error("Erreur réseau");
      }

      const data = await response.json();
      setUtilisateurs(data);
      setFilteredUsers(data);

    } catch (error) {
      console.error("Error fetching users:", error);
      showAlert("Erreur lors du chargement des utilisateurs", "danger");
    } finally {
      setIsLoadingUsers(false);
    }
  };


  // Fonction pour ouvrir le modal d'assignation
  const handleOpenAssignCoachModal = (booking) => {
    setSelectedBookingForCoach(booking);
    setShowAssignCoachModal(true);
    fetchUtilisateurs();
  };

  // Fonction pour fermer le modal
  const handleCloseAssignCoachModal = () => {
    setShowAssignCoachModal(false);
    setSelectedBookingForCoach(null);
    setSearchUserTerm('');
  };

  // Fonction pour rechercher des utilisateurs
  const handleSearchUsers = (term) => {
    setSearchUserTerm(term);
    if (!term.trim()) {
      setFilteredUsers(utilisateurs);
      return;
    }

    const filtered = utilisateurs.filter(user =>
      user.nom?.toLowerCase().includes(term.toLowerCase()) ||
      user.prenoms?.toLowerCase().includes(term.toLowerCase()) ||
      user.email?.toLowerCase().includes(term.toLowerCase())
    );
    setFilteredUsers(filtered);
  };

  // Fonction pour assigner un coach
  const [loadingAssignId, setLoadingAssignId] = useState(null);

  // Modifiez la fonction handleAssignCoach pour gérer l'état par utilisateur
  const handleAssignCoach = async (utilisateur) => {
    try {
      setLoadingAssignId(utilisateur.id); // Définir l'ID en cours de chargement
      const token = localStorage.getItem('access_token');

      const response = await fetch(`${process.env.REACT_APP_HOTE}/assigner-coach-booking/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          booking_id: selectedBookingForCoach.id,
          coach_id: utilisateur.id,
          user_id: user_id
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        showAlertModal(data.message || 'Erreur lors de l\'assignation');
      }

      if (data.status === 'success') {
        showAlert(`Coach ${utilisateur.prenoms} ${utilisateur.nom} assigné avec succès`, 'success');
        handleCloseAssignCoachModal();
        fetchBookings();
      } else {
        showAlertModal(data.message || 'Erreur lors de l\'assignation');
      }

    } catch (error) {
      console.error('Erreur lors de l\'assignation:', error);
      showAlertModal(`Erreur: ${error.message}`, 'danger');
    } finally {
      setLoadingAssignId(null); // Réinitialiser l'ID après le traitement
    }
  };


  const handlePreviousMonth = () => {
    setCurrentMonth(prev => moment(prev).subtract(1, 'month'));
  };

  const handleNextMonth = () => {
    setCurrentMonth(prev => moment(prev).add(1, 'month'));
  };

  const handleToday = () => {
    setCurrentMonth(moment());
    setSelectedDate(moment());
  };

  const handleBookingSelect = (booking) => {
    setSelectedBooking(booking);
  };

  const handleBookingModalOpen = (booking = null) => {
    if (booking) {
      // Si le booking existe, charger ses dates
      const datesFromBooking = booking.dates_booking && booking.dates_booking.length > 0
        ? booking.dates_booking.map(dateObj => ({
          date: typeof dateObj === 'string' ? dateObj : dateObj.date,
          heure_deb: typeof dateObj === 'string' ? booking.heure_deb : (dateObj.heure_deb || booking.heure_deb),
          heure_fin: typeof dateObj === 'string' ? booking.heure_fin : (dateObj.heure_fin || booking.heure_fin)
        }))
        : (booking.date_booking ? [{
          date: booking.date_booking,
          heure_deb: booking.heure_deb,
          heure_fin: booking.heure_fin
        }] : []);

      setNouveauBooking({
        id: booking?.id,
        titre: booking?.title,
        type_booking: booking?.type,
        description: booking?.description,
        couleur: booking?.color,
        type_crenau: booking?.type_crenau || 'en_ligne',
        nb_participants: booking?.nb_participants || 0,
        lien_teams: booking?.lien_teams || '',
        lieu: booking?.lieu || '',
      });
      setSelectedDates(datesFromBooking);
    } else {
      // Nouveau booking - AUCUNE DATE PAR DÉFAUT
      setNouveauBooking({
        titre: '',
        type_booking: '',
        description: '',
        couleur: '#6366f1',
        type_crenau: 'en_ligne',
        nb_participants: 1,
        lien_teams: '',
        lieu: '',
      });
      setSelectedDates([]);
    }
    setShowBookingModal(true);
  };

  // Fonctions pour gérer les dates multiples
  const handleAddDate = (date) => {
    const dateStr = moment(date).format('YYYY-MM-DD');
    const today = moment().startOf('day');

    // Vérifier si la date est dans le passé
    // if (moment(date).isBefore(today)) {
    //   showAlertModal('Impossible d\'ajouter une date déjà passée', 'warning');
    //   return;
    // }

    if (!selectedDates.some(item => {
      const itemDate = typeof item === 'string' ? item : item.date;
      return itemDate === dateStr;
    })) {
      setSelectedDates(prev => [...prev, {
        date: dateStr,
        heure_deb: '09:00',
        heure_fin: '10:00'
      }]);
    }
  };

  const handleRemoveDate = (dateToRemove) => {
    setSelectedDates(prev => prev.filter(date => date !== dateToRemove));
  };

  const handleAddToday = () => {
    const today = moment().format('YYYY-MM-DD');
    handleAddDate(today);
  };

  const handleAddDateRange = (startDate, endDate) => {
    const start = moment(startDate);
    const end = moment(endDate);
    const newDates = [];

    for (let date = start; date.isSameOrBefore(end); date.add(1, 'days')) {
      const dateStr = date.format('YYYY-MM-DD');
      if (!selectedDates.includes(dateStr)) {
        newDates.push(dateStr);
      }
    }

    setSelectedDates(prev => [...prev, ...newDates]);
  };


  // Fonction de validation du lien Teams
  const isValidTeamsLink = (url) => {
    if (!url) return false;

    // Expression régulière pour valider les liens Teams (inclut teams.microsoft.com et teams.live.com)
    const teamsRegex = /^https:\/\/(?:teams\.microsoft\.com|teams\.live\.com|.*\.teams\.microsoft\.com)\/.*/i;

    // Validation de base d'URL
    try {
      const urlObj = new URL(url);

      // Vérifier que c'est bien un URL HTTPS
      if (urlObj.protocol !== 'https:') {
        return false;
      }

      // Vérifier le domaine Teams
      if (!teamsRegex.test(url)) {
        return false;
      }

      return true;
    } catch (error) {
      return false; // URL invalide
    }
  };

  const handleSaveBooking = async () => {
    try {
      setIsChargement(true);

      if (!nouveauBooking?.titre?.trim()) {
        showAlertModal('Le titre est obligatoire', 'warning');
        return;
      }
      if (!nouveauBooking?.type_booking?.trim()) {
        showAlertModal('Le type de booking est obligatoire', 'warning');
        return;
      }
      // if (!nouveauBooking?.description?.trim()) {
      //   showAlertModal('La description est obligatoire', 'warning');
      //   return;
      // }
      if (selectedDates.length === 0) {
        showAlertModal('Au moins une date doit être sélectionnée', 'warning');
        return;
      }

      if (nouveauBooking?.heure_fin <= nouveauBooking?.heure_deb) {
        showAlertModal('L\'heure de fin doit être après l\'heure de début', 'warning');
        return;
      }

      // VALIDATION DU LIEN TEAMS SI FORMAT EN LIGNE
      if (nouveauBooking.type_crenau === 'en_ligne' || nouveauBooking.type_crenau === 'deux') {
        if (!nouveauBooking.lien_teams?.trim()) {
          showAlertModal('Le lien Teams est obligatoire pour les bookings en ligne', 'warning');
          return;
        }

        // Validation du format du lien Teams
        if (!isValidTeamsLink(nouveauBooking.lien_teams)) {
          showAlertModal('Le lien Teams n\'est pas valide. Il doit commencer par https://teams.microsoft.com/', 'warning');
          return;
        }
      }

      // Valider que chaque date a des heures valides
      for (const dateObj of selectedDates) {
        const date = typeof dateObj === 'string' ?
          { date: dateObj, heure_deb: '09:00', heure_fin: '10:00' } : dateObj;

        if (date.heure_fin <= date.heure_deb) {
          showAlertModal(`L'heure de fin doit être après l'heure de début pour le ${moment(date.date).format('DD/MM/YYYY')}`, 'warning');
          return;
        }
      }

      const requestBody = {
        user_id: user_id,
        titre: nouveauBooking?.titre,
        type_booking: nouveauBooking?.type_booking,
        couleur: nouveauBooking?.couleur,
        description: nouveauBooking?.description,
        type_crenau: nouveauBooking?.type_crenau,
        nb_participants: nouveauBooking?.nb_participants || 0,
        lien_teams: nouveauBooking?.lien_teams,
        lieu: nouveauBooking?.lieu,
        dates_booking: selectedDates.map(dateObj => {
          // Normaliser le format des dates
          if (typeof dateObj === 'string') {
            return {
              date: dateObj,
              heure_deb: '09:00',
              heure_fin: '10:00'
            };
          }
          return dateObj;
        })
      };
      const token = localStorage.getItem('access_token');

      if (nouveauBooking?.id) {

        const response = await fetch(`${process.env.REACT_APP_HOTE}/modifier-bookings/${nouveauBooking?.id}/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
          throw new Error('Erreur lors de la modification');
        }

        const data = await response.json();

        if (data.status === 'success') {
          const updatedBooking = {
            id: data.booking?.id,
            reference: data.booking?.reference,
            title: data.booking?.titre,
            type: data.booking?.type_booking,
            description: data.booking?.description,
            color: data.booking?.couleur,
            nb_participants: data.booking?.nb_participants || 0,
            heure_deb: data.booking?.heure_deb || '09:00',
            heure_fin: data.booking?.heure_fin || '10:00',
            type_crenau: data.booking?.type_crenau || 'en_ligne',
            dates_booking: data.booking?.dates_booking || [], // AJOUTER
            date_booking: data.booking?.date_booking,
            lieu: data.booking?.lieu,
          };

          setAvailableBookings(availableBookings.map(b =>
            b.id === nouveauBooking?.id ? updatedBooking : b
          ));

          if (selectedBooking?.id === nouveauBooking?.id) {
            setSelectedBooking(updatedBooking);
          }

          showAlert('Booking modifié avec succès', 'success');
          setShowBookingModal(false);
        } else {
          throw new Error(data.message || 'Erreur lors de la modification');
        }
      } else {
        const response = await fetch(`${process.env.REACT_APP_HOTE}/ajouter-bookings/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(requestBody),
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message);
        }

        if (data.status === 'success') {
          const newBooking = {
            id: data.booking?.id,
            title: data.booking?.titre,
            type: data.booking?.type_booking,
            description: data.booking?.description,
            color: data.booking?.couleur,
            nb_participants: data.booking?.nb_participants || 0,
            heure_deb: data.booking?.heure_deb || '09:00',
            heure_fin: data.booking?.heure_fin || '10:00',
            type_crenau: data.booking?.type_crenau || 'en_ligne',
            date_booking: data.booking?.date_booking // AJOUT ICI AUSSI
          };

          setAvailableBookings([newBooking, ...availableBookings]);
          setSelectedBooking(newBooking);
          showAlert('Booking créé avec succès !', 'success');
          setShowBookingModal(false);
        } else {
          throw new Error(data.message || 'Erreur lors de la création');
        }
      }

    } catch (error) {
      console.error('Erreur lors de la sauvegarde:', error);
      showAlertModal(`Erreur: ${error.message}`, 'danger');
    } finally {
      setIsChargement(false);
      fetchBookings()
    }
  };

  const handleDeleteBooking = async () => {
    if (bookingToDelete) {
      try {
        const token = localStorage.getItem('access_token');

        const response = await fetch(
          `${process.env.REACT_APP_HOTE}/supprimer-bookings/${bookingToDelete.id}/${user_id}/`,
          {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
          }
        );

        if (response.ok) {
          const updatedBookings = availableBookings.filter(b => b.id !== bookingToDelete.id);
          setAvailableBookings(updatedBookings);

          if (selectedBooking?.id === bookingToDelete.id) {
            setSelectedBooking(updatedBookings.length > 0 ? updatedBookings[0] : null);
          }

          showAlert("Booking supprimé avec succès !");
          fetchBookings();
        } else {
          console.error('Erreur lors de la suppression du booking');
          showAlert("Erreur lors de la suppression du booking", "danger");
        }
      } catch (error) {
        console.error('Erreur réseau:', error);
        showAlert("Erreur réseau, réessayez plus tard", "danger");
      } finally {
        setShowDeleteModal(false);
        setBookingToDelete(null);
      }
    }
  };

  const handleDeleteClick = (booking, e) => {
    e.stopPropagation();
    setBookingToDelete(booking);
    setShowDeleteModal(true);
  };

  // Logique des réservations
  const fetchReservations = async () => {
    setIsLoadingReservations(true);
    try {
      const token = localStorage.getItem('access_token');

      let url = `${process.env.REACT_APP_HOTE}/liste-reservations/`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
      });

      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des réservations');
      }

      const data = await response.json();

      if (data.status === 'success') {
        setReservations(data.reservations);

        // Extraire les créneaux uniques pour le filtrage
        const uniqueCreneaux = [];
        const creneauxSet = new Set();

        data.reservations?.forEach(reservation => {
          const creneauKey = `${reservation.date}_${reservation.heure_deb}_${reservation.heure_fin}`;
          if (!creneauxSet.has(creneauKey)) {
            creneauxSet.add(creneauKey);
            uniqueCreneaux.push({
              id: creneauKey,
              date: reservation.date,
              heure_deb: reservation.heure_deb,
              heure_fin: reservation.heure_fin,
              display: `${moment(reservation.date).format('DD/MM/YYYY')} - ${reservation.heure_deb} à ${reservation.heure_fin}`
            });
          }
        });

        setAvailableCreneaux(uniqueCreneaux);
        setCreneauxFilter('all');
      } else {
        throw new Error(data.message || 'Erreur inconnue');
      }

    } catch (error) {
      console.error('Erreur:', error);
      showAlert(`Erreur de chargement des réservations: ${error.message}`, 'danger');
    } finally {
      setIsLoadingReservations(false);
    }
  };

  const getFilteredReservations = () => {
    if (creneauxFilter === 'all') {
      return reservations;
    }

    return reservations.filter(reservation => {
      const creneauKey = `${reservation.date}_${reservation.heure_deb}_${reservation.heure_fin}`;
      return creneauKey === creneauxFilter;
    });
  };

  const handleOpenConfirmModal = (reservation) => {
    setSelectedReservation(reservation);
    setShowConfirmModal(true);
  };

  const handleOpenCancelModal = (reservation) => {
    setSelectedReservation(reservation);
    setShowCancelModal(false);
  };




  const handleOpenStatutModal = (booking) => {
    setSelectedBooking(booking);
    setShowStatutModal(true);
  };

  const handleCloseStatutModal = (booking) => {
    setSelectedBooking(booking);
    setShowStatutModal(false);
  };

  const handleOpenCancelModalFromReservations = (reservation) => {
    setSelectedReservation(reservation);
    setShowReservationsModal(false); // Fermer le modal des réservations
    setShowCancelModal(true); // Ouvrir le modal d'annulation
  };

  const handleConfirmAction = async () => {
    if (selectedReservation) {
      await handleChangeReservationStatus(selectedReservation.id, 2);
      setShowConfirmModal(false);
      setSelectedReservation(null);
    }
  };

  const handleCancelAction = async () => {
    if (selectedReservation && annulationMotif.trim()) {
      await handleChangeReservationStatus(selectedReservation.id, 3, annulationMotif);
      setShowCancelModal(false);
      setSelectedReservation(null);
      setAnnulationMotif('');

      // Rouvrir le modal des réservations si on venait de là
      if (selectedBookingForReservations) {
        setTimeout(() => {
          setShowReservationsModal(true);
        }, 100); // Petit délai pour la fluidité
      }
    } else {
      showAlertModal('Veuillez saisir un motif d\'annulation', 'warning');
    }
  };

  // Ajoutez cette fonction
  const handleCloseCancelModal = () => {
    setShowCancelModal(false);
    setAnnulationMotif('');
    setSelectedReservation(null);

    // Rouvrir le modal des réservations si on venait de là
    if (selectedBookingForReservations) {
      setTimeout(() => {
        setShowReservationsModal(true);
      }, 100);
    }
  };

  const handleChangeReservationStatus = async (reservationId, newStatus, motif = '') => {
    try {
      setIsChargement(true);

      const requestBody = {
        reservation_id: reservationId,
        statut: newStatus,
        user_id: user_id
      };

      if (newStatus === 3 && motif) {
        requestBody.motif_annulation = motif;
      }
      const token = localStorage.getItem('access_token');

      const response = await fetch(`${process.env.REACT_APP_HOTE}/modifier-statut-reservation/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Erreur lors de la modification du statut');
      }

      if (data.status === 'success') {
        setReservations(prevReservations =>
          prevReservations.map(reservation =>
            reservation.id === reservationId
              ? {
                ...reservation,
                statut: newStatus,
                ...(newStatus === 3 && motif && { motif_annulation: motif })
              }
              : reservation
          )
        );

        showAlert(data.message, 'success');
        fetchReservations(selectedBooking?.id);
        fetchBookings();
        setShowBookingModal(false)
      } else {
        throw new Error(data.message || 'Erreur lors de la modification du statut');
      }

    } catch (error) {
      console.error('Erreur lors de la modification du statut:', error);
      showAlert(`Erreur: ${error.message}`, 'danger');
    } finally {
      setIsChargement(false);
    }
  };

  const canCancelReservation = (reservation) => {
    if (!reservation?.date || !reservation?.heure_deb) return false;

    const reservationDateTime = moment(`${reservation.date} ${reservation.heure_deb}`, 'YYYY-MM-DD HH:mm');
    const now = moment();
    const timeDifference = reservationDateTime.diff(now, 'hours', true);

    return timeDifference > 24;
  };




  const filteredReservations = getFilteredReservations();

  // États pour la pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({ key: 'date_creation', direction: 'descending' });

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentReservations = filteredReservations.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredReservations.length / itemsPerPage);

  const renderReservations = () => {
    if (isLoadingReservations) {
      return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
          <div className="spiner-example">
            <div className="sk-spinner sk-spinner-wave">
              <div className="sk-rect1 mr-1"></div>
              <div className="sk-rect2 mr-1"></div>
              <div className="sk-rect3 mr-1"></div>
              <div className="sk-rect4 mr-1"></div>
              <div className="sk-rect5"></div>
            </div>
          </div>
        </div>
      );
    }

    const filteredReservations = getFilteredReservations();

    // Fonction de tri
    const handleSort = (key) => {
      let direction = 'ascending';
      if (sortConfig.key === key && sortConfig.direction === 'ascending') {
        direction = 'descending';
      }
      setSortConfig({ key, direction });
    };

    // Appliquer le tri aux réservations
    const sortedReservations = [...filteredReservations].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });

    return (
      <div className="reservations-container">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h4 className="mb-1">Réservations</h4>
            <p className="text-muted mb-0">
              {sortedReservations.length} réservation{sortedReservations.length !== 1 ? 's' : ''}
            </p>
          </div>

          <div className="d-flex align-items-center gap-3">
            {availableCreneaux.length > 0 && (
              <Form.Select
                value={creneauxFilter}
                onChange={(e) => setCreneauxFilter(e.target.value)}
                style={{ width: 'auto', minWidth: '250px' }}
                size="sm"
              >
                <option value="all">Tous les créneaux</option>
                {availableCreneaux.map(creneau => (
                  <option key={creneau.id} value={creneau.id}>
                    {creneau.display}
                  </option>
                ))}
              </Form.Select>
            )}

            <div className="d-flex align-items-center gap-2">
              {/* <Badge bg="success" className="fs-6">
                {sortedReservations.length} réservation{sortedReservations.length !== 1 ? 's' : ''}
              </Badge> */}
              {creneauxFilter !== 'all' && (
                <Badge
                  bg="secondary"
                  className="fs-6 cursor-pointer text-white"
                  onClick={() => setCreneauxFilter('all')}
                >
                  <FaTimes className="me-1" />
                  Effacer le filtre
                </Badge>
              )}
            </div>
          </div>
        </div>

        {sortedReservations.length > 0 ? (
          <div className="ibox">
            <div className="ibox-content">
              {/* Supprimer les contrôles de pagination en haut */}

              <div className="">
                <table className="footable table table-stripped footable-loaded tablet breakpoint">
                  <thead>
                    <tr>
                      <th
                        className='text-secondary text-wrap cursor-pointer'
                        onClick={() => handleSort('date_creation')}
                        style={{ cursor: 'pointer' }}
                      >
                        Date de réservation
                        {sortConfig.key === 'date_creation' && (
                          sortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                        )}
                      </th>
                      <th
                        className='text-secondary text-wrap cursor-pointer'
                        onClick={() => handleSort('nom')}
                        style={{ cursor: 'pointer' }}
                      >
                        Client
                        {sortConfig.key === 'nom' && (
                          sortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                        )}
                      </th>
                      <th
                        className='text-secondary text-wrap d-none d-md-table-cell cursor-pointer'
                        onClick={() => handleSort('email')}
                        style={{ cursor: 'pointer' }}
                      >
                        Contact
                        {sortConfig.key === 'email' && (
                          sortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                        )}
                      </th>
                      <th
                        className='text-secondary text-wrap cursor-pointer'
                        onClick={() => handleSort('date')}
                        style={{ cursor: 'pointer' }}
                      >
                        Date du booking
                        {sortConfig.key === 'date' && (
                          sortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                        )}
                      </th>
                      <th
                        className='text-secondary text-wrap cursor-pointer'
                        onClick={() => handleSort('type_crenau')}
                        style={{ cursor: 'pointer' }}
                      >
                        Type
                        {sortConfig.key === 'type_crenau' && (
                          sortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                        )}
                      </th>
                      <th
                        className='text-secondary text-wrap cursor-pointer'
                        onClick={() => handleSort('statut')}
                        style={{ cursor: 'pointer' }}
                      >
                        Statut
                        {sortConfig.key === 'statut' && (
                          sortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                        )}
                      </th>
                      <th
                        className='text-secondary text-wrap cursor-pointer'
                        onClick={() => handleSort('motif_annulation')}
                        style={{ cursor: 'pointer' }}
                      >
                        Motif
                        {sortConfig.key === 'motif_annulation' && (
                          sortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                        )}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedReservations.map((reservation) => (
                      <tr key={reservation.id} className="bg-white">
                        <td>
                          <div className="fw-bold">
                            Réservé le {moment(reservation.date_creation).format('DD/MM/YYYY à HH:mm')}
                          </div>
                        </td>
                        <td>
                          <div className="fw-bold">
                            {reservation.prenom} {reservation.nom}
                          </div>
                          <div className="lesInfos">
                            <small className="text-muted">
                              Réservé le {moment(reservation.date_creation).format('DD/MM/YYYY à HH:mm')}
                            </small>
                          </div>
                        </td>
                        <td className="d-none d-md-table-cell">
                          <div className="d-flex flex-column">
                            <small>
                              <FaUser size={12} className="mr-1" />
                              {reservation.email}
                            </small>
                            <small className="mt-1">
                              <FaPhone size={12} className="mr-1" />
                              {reservation.telephone || 'Non renseigné'}
                            </small>
                          </div>
                        </td>
                        <td>
                          <div className="fw-bold text-dark">
                            {moment(reservation.date).format('DD/MM/YYYY')}
                          </div>
                          <div className="text-muted small">
                            {reservation.heure_deb} - {reservation.heure_fin}
                          </div>
                        </td>
                        <td>
                          <div>
                            {reservation.type_crenau === 'en_ligne' ? 'En ligne' : 'Présentiel'}
                          </div>
                          {reservation.statut === '2' && reservation.type_crenau === 'en_ligne' && (
                            <a
                              href={reservation.lien_teams}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-decoration-none ms-1"
                              title="Rejoindre la visioconférence Teams"
                            >
                              <FaVideo className="text-primary" size={14} />
                            </a>
                          )}
                        </td>
                        <td>
                          <Badge
                            bg={
                              reservation.statut === '1' ? 'warning' :
                                reservation.statut === '2' ? 'success' :
                                  'danger'
                            }
                          >
                            {reservation.statut === '1' && 'En attente'}
                            {reservation.statut === '2' && 'Confirmée'}
                            {reservation.statut === '3' && 'Annulée'}
                          </Badge>
                        </td>
                        <td>
                          {reservation.statut === '3' && reservation.motif_annulation && (
                            <div className="mt-1">
                              <small className="text-muted">
                                {reservation.motif_annulation}
                              </small>
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Afficher juste le nombre total d'éléments */}
              <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="dataTables_info" role="status" aria-live="polite">
                  {sortedReservations.length === 0
                    ? "Aucune réservation à afficher"
                    : `Affichage de ${sortedReservations.length} réservation${sortedReservations.length !== 1 ? 's' : ''}`}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center py-5">
            <FaUser size={40} className="text-muted mb-3" />
            <h5 className="text-muted">Aucune réservation</h5>
            <p className="text-muted">
              Aucune réservation n'a été faite pour ce booking pour le moment.
            </p>
          </div>
        )}
      </div>
    );
  };


  // états pour modal détails reser
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedBookingDetails, setSelectedBookingDetails] = useState(null);

  const handleShowDetailsModal = (booking) => {
    setSelectedBookingDetails(booking);
    setShowDetailsModal(true);
  };


  // États pour la pagination et tri des bookings
  const [currentBookingPage, setCurrentBookingPage] = useState(1);
  const [bookingItemsPerPage, setBookingItemsPerPage] = useState(10);
  const [bookingSortConfig, setBookingSortConfig] = useState({ key: 'date_booking', direction: 'descending' });
  const [bookingSearchTerm, setBookingSearchTerm] = useState('');
  const [coachFilter, setCoachFilter] = useState('all');
  const [moisFilter, setMoisFilter] = useState('all');


  // Fonctions pour le tri et la pagination des bookings
  const handleBookingSort = (key) => {
    let direction = 'ascending';
    if (bookingSortConfig.key === key && bookingSortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setBookingSortConfig({ key, direction });
  };

  // Filtrer les bookings par terme de recherche


  const getCoachsUniques = () => {
    const coachs = availableBookings
      .map(b => b.nom_coach)
      .filter(Boolean)
      .filter((v, i, arr) => arr.indexOf(v) === i)
      .sort();
    return coachs;
  };

  const getFilteredBookings = () => {
    let result = availableBookings;

    // Filtre par recherche texte
    if (bookingSearchTerm) {
      result = result.filter(booking =>
        booking.title?.toLowerCase().includes(bookingSearchTerm.toLowerCase()) ||
        booking.nom_coach?.toLowerCase().includes(bookingSearchTerm.toLowerCase()) ||
        booking.type?.toLowerCase().includes(bookingSearchTerm.toLowerCase()) ||
        booking.description?.toLowerCase().includes(bookingSearchTerm.toLowerCase()) ||
        booking.type_crenau?.toLowerCase().includes(bookingSearchTerm.toLowerCase())
      );
    }

    // ✅ Filtre par coach
    if (coachFilter !== 'all') {
      result = result.filter(b => b.nom_coach === coachFilter);
    }

    // ✅ Filtre par mois
    if (moisFilter !== 'all') {
      result = result.filter(b => {
        if (!b.date_booking) return false;
        return moment(b.date_booking).format('YYYY-MM') === moisFilter;
      });
    }

    return result;
  };

  // Appliquer le tri aux bookings
  const getSortedBookings = () => {
    const filteredBookings = getFilteredBookings();

    return [...filteredBookings].sort((a, b) => {
      if (a[bookingSortConfig.key] < b[bookingSortConfig.key]) {
        return bookingSortConfig.direction === 'ascending' ? -1 : 1;
      }
      if (a[bookingSortConfig.key] > b[bookingSortConfig.key]) {
        return bookingSortConfig.direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });
  };


  // Fonction pour calculer la durée entre deux heures
  const calculerDuree = (heureDebut, heureFin) => {
    try {
      const [heuresDebut, minutesDebut] = heureDebut.split(':').map(Number);
      const [heuresFin, minutesFin] = heureFin.split(':').map(Number);

      const debutEnMinutes = heuresDebut * 60 + minutesDebut;
      const finEnMinutes = heuresFin * 60 + minutesFin;
      const dureeMinutes = finEnMinutes - debutEnMinutes;

      const heures = Math.floor(dureeMinutes / 60);
      const minutes = dureeMinutes % 60;

      // Retourner "8H" ou "8H30" selon s'il y a des minutes
      return minutes > 0 ? `${heures}H${minutes}` : `${heures}H`;
    } catch (error) {
      console.error('Erreur calcul durée:', error);
      return '0H';
    }
  };

  // Pagination des bookings
  const indexOfLastBooking = currentBookingPage * bookingItemsPerPage;
  const indexOfFirstBooking = indexOfLastBooking - bookingItemsPerPage;
  const currentBookings = getSortedBookings().slice(indexOfFirstBooking, indexOfLastBooking);
  const totalBookingPages = Math.ceil(getSortedBookings().length / bookingItemsPerPage);

  const renderBookingsList = () => {
    const sortedBookings = getSortedBookings();

    return (
      <div className="bookings-list-container">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h4 className="mb-1">Liste des bookings</h4>
            <p className="text-muted mb-0">
              {sortedBookings.length} booking{sortedBookings.length !== 1 ? 's' : ''}
            </p>
          </div>

          <div className="d-flex align-items-center gap-3 flex-wrap">
            {/* Nombre d'éléments par page */}
            <div className="d-flex align-items-center gap-2">
              <Form.Select
                size="sm"
                style={{ width: 'auto', marginRight: '4px' }}
                value={bookingItemsPerPage}
                onChange={(e) => {
                  setBookingItemsPerPage(Number(e.target.value));
                  setCurrentBookingPage(1);
                }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </Form.Select>
            </div>

            {/* ✅ Filtre par coach */}
            <Form.Select
              size="sm"
              style={{ width: 'auto', minWidth: '180px', marginRight: '4px'  }}
              value={coachFilter}
              onChange={(e) => {
                setCoachFilter(e.target.value);
                setCurrentBookingPage(1);
              }}
            >
              <option value="all">Filtrer par coach</option>
              {getCoachsUniques().map((coach, idx) => (
                <option key={idx} value={coach}>{coach}</option>
              ))}
            </Form.Select>

            {/* ✅ Filtre par mois */}
            <Form.Select
              size="sm"
              style={{ width: 'auto', minWidth: '160px', marginRight: '4px'  }}
              value={moisFilter}
              onChange={(e) => {
                setMoisFilter(e.target.value);
                setCurrentBookingPage(1);
              }}
            >
              <option value="all">Filtrer par mois</option>
              {Array.from({ length: 12 }, (_, i) => {
                const date = moment().subtract(i, 'months');
                return (
                  <option key={i} value={date.format('YYYY-MM')}>
                    {date.format('MMMM YYYY')}
                  </option>
                );
              })}
            </Form.Select>

            {(coachFilter !== 'all' || moisFilter !== 'all' || bookingSearchTerm) && (
              <Button
                variant="secondary"
                size="sm"
                onClick={() => {
                  setCoachFilter('all');
                  setMoisFilter('all');
                  setBookingSearchTerm('');
                  setCurrentBookingPage(1);
                }}
                className="d-flex align-items-center mr-2"
              >
                <FaTimes className="me-1" />
                Réinitialiser
              </Button>
            )}

            {/* Barre de recherche */}
            <div className="position-relative">
              <Form.Control
                type="text"
                placeholder="Rechercher"
                value={bookingSearchTerm}
                onChange={(e) => {
                  setBookingSearchTerm(e.target.value);
                  setCurrentBookingPage(1);
                }}
                style={{ width: '250px' }}
                size="sm"
              />
              <FaSearch
                className="position-absolute text-muted"
                style={{ right: '12px', top: '50%', transform: 'translateY(-50%)' }}
              />
            </div>
          </div>
        </div>

        {sortedBookings.length > 0 ? (
          <div className="ibox">
            <div className="ibox-content">
              <div className="">
                <table className="footable table table-stripped footable-loaded tablet breakpoint">
                  <thead>
                    <tr>
                      <th
                        className='text-secondary text-wrap cursor-pointer'
                        onClick={() => handleBookingSort('title')}
                        style={{ cursor: 'pointer' }}
                      >
                        Titre
                        {bookingSortConfig.key === 'title' && (
                          bookingSortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                        )}
                      </th>
                      <th
                        className='text-secondary text-wrap cursor-pointer'
                        onClick={() => handleBookingSort('nom_coach')}
                        style={{ cursor: 'pointer' }}
                      >
                        Coach
                        {bookingSortConfig.key === 'nom_coach' && (
                          bookingSortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                        )}
                      </th>
                      <th
                        className='text-secondary text-wrap cursor-pointer'
                        onClick={() => handleBookingSort('type')}
                        style={{ cursor: 'pointer' }}
                      >
                        Type
                        {bookingSortConfig.key === 'type' && (
                          bookingSortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                        )}
                      </th>
                      <th
                        className='text-secondary text-wrap cursor-pointer'
                        onClick={() => handleBookingSort('date_booking')}
                        style={{ cursor: 'pointer' }}
                      >
                        Date
                        {bookingSortConfig.key === 'date_booking' && (
                          bookingSortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                        )}
                      </th>
                      <th
                        className='text-secondary text-center cursor-pointer'
                        onClick={() => handleBookingSort('heure_deb')}
                        style={{ cursor: 'pointer' }}
                      >
                        Nbre d'heure
                        {bookingSortConfig.key === 'heure_deb' && (
                          bookingSortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                        )}
                      </th>
                      <th
                        className='text-secondary text-wrap cursor-pointer'
                        onClick={() => handleBookingSort('nbre_heure')}
                        style={{ cursor: 'pointer' }}
                      >
                        Heure effectif
                        {bookingSortConfig.key === 'nbre_heure' && (
                          bookingSortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                        )}
                      </th>
                      {/* <th
                        className='text-secondary text-wrap cursor-pointer'
                        onClick={() => handleBookingSort('type_crenau')}
                        style={{ cursor: 'pointer' }}
                      >
                        Format
                        {bookingSortConfig.key === 'type_crenau' && (
                          bookingSortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                        )}
                      </th> */}
                      {/* <th
                        className='text-secondary text-wrap cursor-pointer'
                        onClick={() => handleBookingSort('lieu')}
                        style={{ cursor: 'pointer' }}
                      >
                        Lieu
                        {bookingSortConfig.key === 'lieu' && (
                          bookingSortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                        )}
                      </th> */}
                      <th
                        className='text-secondary text-wrap cursor-pointer'
                        onClick={() => handleBookingSort('nb_participants')}
                        style={{ cursor: 'pointer' }}
                      >
                        Places réservés
                        {bookingSortConfig.key === 'nb_participants' && (
                          bookingSortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                        )}
                      </th>
                      <th
                        className='text-secondary text-wrap cursor-pointer'
                        onClick={() => handleBookingSort('statut')}
                        style={{ cursor: 'pointer' }}
                      >
                        Statut
                        {bookingSortConfig.key === 'statut' && (
                          bookingSortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                        )}
                      </th>
                      <th className='text-secondary text-wrap text-end'>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentBookings.map((booking) => (
                      <tr key={booking.id} className="bg-white">
                        <td>
                          <div className="fw-bold text-dark">
                            {/* {booking.title} */}
                            {booking.title.length > 40
                              ? `${booking.title.substring(0, 40)}...`
                              : booking.title
                            }
                          </div>
                          <div className="text-muted small">
                            {booking.description && (
                              <span title={booking.description}>
                                {booking.description.length > 30
                                  ? `${booking.description.substring(0, 30)}...`
                                  : booking.description
                                }
                              </span>
                            )}
                          </div>
                        </td>
                        <td>
                          {booking.nom_coach}
                        </td>
                        <td>
                          {booking.type}
                        </td>
                        <td>
                          <div className="fw-bold">
                            {moment(booking.date_booking).format('DD/MM/YYYY')} de
                            <span className='ml-1'>{booking.heure_deb} à {booking.heure_fin}</span>
                          </div>
                        </td>
                        <td>
                          <div className="text-center m-0">
                            {calculerDuree(booking.heure_deb, booking.heure_fin)}
                          </div>
                        </td>
                        <td>
                          <div className="text-center m-0">
                            {booking.nbre_heure}H
                          </div>
                        </td>
                        {/* <td>
                          <span>
                            {booking.type_crenau === 'en_ligne' ? 'Virtuel' : 'Présentiel'}
                          </span>
                        </td> */}
                        {/* <td>
                          {booking.type_crenau === 'presentiel' && booking.lieu && (
                            <div className="mt-1 small text-muted">
                              <FaMapMarkerAlt size={10} className="me-1" />
                              {booking.lieu.length > 30 ?
                                `${booking.lieu.substring(0, 30)}...` : booking.lieu}
                            </div>
                          )}
                        </td> */}
                        <td>
                          <span className="badge badge-secondary">
                            {booking?.nombre_reservations} / {booking.nb_place_total}
                          </span>
                        </td>
                        <td>
                          {booking?.statut === "1" ? "En attente" : "Terminé"}
                        </td>
                        <td className='text-center'>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="outline-"
                              size="sm"
                              id={`dropdown-${booking.id}`}
                              className="d-flex align-items-center"
                            >
                              <FaEllipsisV />
                              {/* <i className="fa fa-ellipsis-v"></i> */}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>

                              {/* Bouton Modifier */}
                              <Dropdown.Item
                                onClick={() => handleShowDetailsModal(booking)}
                                className="d-flex align-items-center text-info"
                              >
                                <FaInfoCircle className="mr-2" />
                                Voir détails
                              </Dropdown.Item>
                              {/* Bouton Modifier */}
                              <Dropdown.Item
                                onClick={() => handleBookingModalOpen(booking)}
                                className="d-flex align-items-center"
                              >
                                <FaEdit className="mr-2" />
                                Modifier
                              </Dropdown.Item>

                              {/* NOUVEAU BOUTON - Assigner coach */}
                              <Dropdown.Item
                                onClick={() => handleOpenAssignCoachModal(booking)}
                                className="d-flex align-items-center text-warning"
                              >
                                <FaUser className="mr-2" />
                                Assigner coach
                              </Dropdown.Item>

                              {/* Bouton Réservations */}
                              <Dropdown.Item
                                onClick={() => handleShowReservationsModal(booking)}
                                className="d-flex align-items-center"
                              >
                                <FaUser className="mr-2" />
                                Réservations
                              </Dropdown.Item>

                              {/* Bouton Réservations */}
                              <Dropdown.Item
                                onClick={() => handleOpenStatutModal(booking)}
                                className="d-flex align-items-center"
                              >
                                <FaEdit className="mr-2" />
                                changer statut
                              </Dropdown.Item>

                              {/* Bouton Supprimer */}
                              <Dropdown.Item
                                onClick={(e) => handleDeleteClick(booking, e)}
                                className="d-flex align-items-center text-danger"
                              >
                                <FaTrash className="mr-2" />
                                Supprimer
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              {totalBookingPages > 1 && (
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div className="dataTables_info" role="status" aria-live="polite">
                    Affichage de {indexOfFirstBooking + 1} à {Math.min(indexOfLastBooking, sortedBookings.length)} sur {sortedBookings.length} booking{sortedBookings.length !== 1 ? 's' : ''}
                  </div>

                  <nav>
                    <ul className="pagination pagination-sm mb-0">
                      <li className={`page-item ${currentBookingPage === 1 ? 'disabled' : ''}`}>
                        <button
                          className="page-link"
                          onClick={() => setCurrentBookingPage(prev => Math.max(prev - 1, 1))}
                          disabled={currentBookingPage === 1}
                        >
                          <FaChevronLeft size={12} />
                        </button>
                      </li>

                      {[...Array(totalBookingPages)].map((_, index) => (
                        <li key={index} className={`page-item ${currentBookingPage === index + 1 ? 'active' : ''}`}>
                          <button
                            className="page-link"
                            onClick={() => setCurrentBookingPage(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}

                      <li className={`page-item ${currentBookingPage === totalBookingPages ? 'disabled' : ''}`}>
                        <button
                          className="page-link"
                          onClick={() => setCurrentBookingPage(prev => Math.min(prev + 1, totalBookingPages))}
                          disabled={currentBookingPage === totalBookingPages}
                        >
                          <FaChevronRight size={12} />
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="text-center py-5">
            <FaCalendarAlt size={40} className="text-muted mb-3" />
            <h5 className="text-muted">
              {bookingSearchTerm || coachFilter !== 'all' || moisFilter !== 'all'
                ? 'Aucun booking trouvé'
                : 'Aucun booking créé'}
            </h5>
            <p className="text-muted">
              {bookingSearchTerm || coachFilter !== 'all' || moisFilter !== 'all'
                ? 'Aucun booking ne correspond à vos filtres.'
                : 'Créez votre premier booking pour commencer.'}
            </p>
            {(bookingSearchTerm || coachFilter !== 'all' || moisFilter !== 'all') && (
              <Button
                variant="outline-secondary"
                onClick={() => {
                  setBookingSearchTerm('');
                  setCoachFilter('all');
                  setMoisFilter('all');
                  setCurrentBookingPage(1);
                }}
              >
                <FaTimes className="me-1" />
                Effacer les filtres
              </Button>
            )}
            {!bookingSearchTerm && (
              <Button
                variant="success"
                onClick={() => handleBookingModalOpen()}
              >
                <FaPlus className="me-1" />
                Créer un booking
              </Button>
            )}
            {bookingSearchTerm && (
              <Button
                variant="outline-secondary"
                onClick={() => setBookingSearchTerm('')}
              >
                <FaTimes className="me-1" />
                Effacer la recherche
              </Button>
            )}
          </div>
        )}
      </div>
    );
  };

  const [activeTab, setActiveTab] = useState('calendrier');
  const [calendarView, setCalendarView] = useState('dayGridMonth');
  const [calendarEvents, setCalendarEvents] = useState([]);

  const transformBookingsToEvents = useCallback(() => {
    const events = [];

    availableBookings?.forEach(booking => {
      if (booking.date_booking && booking.heure_deb && booking.heure_fin) {
        const formattedDate = moment(booking.date_booking).format('YYYY-MM-DD');

        events.push({
          id: booking.id,
          title: `${booking.heure_deb} - ${booking.type} (${booking.nb_participants} places)`,
          start: formattedDate + 'T' + booking.heure_deb,
          end: formattedDate + 'T' + booking.heure_fin,
          color: booking.color,
          extendedProps: {
            bookingTitle: booking.title,
            type_booking: booking.type,
            type_crenau: booking.type_crenau,
            nb_participants: booking.nb_participants,
            nb_place_total: booking.nb_place_total,
            bookingColor: booking.color,
            description: booking.description,
            date_booking: booking.date_booking,
            heure_deb: booking.heure_deb,
            heure_fin: booking.heure_fin,
            lieu: booking.lieu,
            reference: booking.reference
          }
        });
      }
    });

    return events;
  }, [availableBookings]);

  useEffect(() => {
    const events = transformBookingsToEvents();
    setCalendarEvents(events);
  }, [transformBookingsToEvents]);

  const handleDateClick = (arg) => {
    const clickedDate = moment(arg.date);
    const today = moment().startOf('day');

    // Vérifier si la date est dans le passé
    if (clickedDate.isBefore(today)) {
      showAlertModal('Impossible de sélectionner une date déjà passée', 'warning');
      return;
    }

    setSelectedDate(clickedDate);
    handleAddDate(clickedDate);

    // Ouvrir le modal d'ajout du booking avec la date pré-remplie
    setNouveauBooking({
      titre: '',
      type_booking: '',
      description: '',
      couleur: '#6366f1',
      heure_deb: '09:00',
      heure_fin: '10:00',
      type_crenau: 'presentiel',
      nb_participants: 1,
      date_booking: clickedDate.format('YYYY-MM-DD')
    });
    setShowBookingModal(true);
  };



  const handleEventClick = (clickInfo) => {
    const bookingId = clickInfo.event.extendedProps.bookingId;
    const booking = availableBookings.find(b => b.id === bookingId);
    if (booking) {
      setSelectedBooking(booking);

      const event = clickInfo.event;
      let details = `📅 <strong>${event.title}</strong><br>`;

      if (event.extendedProps.is_multi_date) {
        details += `📅 Date: ${moment(event.start).format('DD/MM/YYYY')} (Session parmi ${booking.dates_booking?.length || 0} dates)<br>`;
      } else {
        details += `📅 Date: ${moment(event.start).format('DD/MM/YYYY')}<br>`;
      }

      details += `⏰ Heure: ${moment(event.start).format('HH:mm')} - ${moment(event.end).format('HH:mm')}<br>`;
      details += `👥 Participants: ${event.extendedProps.nb_participants}<br>`;
      details += `📝 ${event.extendedProps.description || 'Aucune description'}`;

      showAlert(details, 'info');
    }
  };

  const [editingDate, setEditingDate] = useState(null);

  const renderDateManager = () => {
    const handleTimeChange = (dateToUpdate, field, value) => {
      setSelectedDates(prev =>
        prev.map(item => {
          // Extraire la date de l'item (qu'il soit string ou objet)
          const itemDate = typeof item === 'string' ? item : item.date;

          // Si c'est l'item qu'on veut mettre à jour
          if (itemDate === dateToUpdate) {
            // Si c'est une string simple, la convertir en objet
            if (typeof item === 'string') {
              return {
                date: item,
                heure_deb: field === 'heure_deb' ? value : '09:00',
                heure_fin: field === 'heure_fin' ? value : '10:00'
              };
            }
            // Si c'est déjà un objet, mettre à jour le champ spécifique
            return {
              ...item,
              [field]: value
            };
          }
          return item;
        })
      );
    };

    const handleRemoveDate = (dateToRemove) => {
      setSelectedDates(prev => prev.filter(item => {
        const itemDate = typeof item === 'string' ? item : item.date;
        return itemDate !== dateToRemove;
      }));
    };

    const getDateObject = (dateItem) => {
      if (typeof dateItem === 'string') {
        return {
          date: dateItem,
          heure_deb: '09:00',
          heure_fin: '10:00'
        };
      }
      return dateItem;
    };

    return (
      <div className="date-manager">
        <Form.Group className="mb-1">
          <Form.Label>
            <strong>Dates du booking <span className='text-danger'>*</span></strong>
            <span className="badge badge-secondary ml-2">
              {selectedDates.length} date{selectedDates.length !== 1 ? 's' : ''} sélectionnée{selectedDates.length !== 1 ? 's' : ''}
            </span>
          </Form.Label>

          {/* Liste des dates avec leurs heures */}
          <div className="selected-dates-list">
            {selectedDates.length > 0 ? (
              <div className="d-flex flex-column gap-2">
                {selectedDates.map((dateItem, index) => {
                  const dateObj = getDateObject(dateItem);

                  return (
                    <div key={index} className="d-flex align-items-center justify-content-between p-2 border rounded bg-light">
                      <div className="d-flex align-items-center gap-3 flex-grow-1">
                        {/* Date */}
                        <div className="d-flex align-items-center mr-3">
                          <FaCalendarDay className="me-2 text-primary" />
                          <strong>{moment(dateObj.date).format('DD/MM/YYYY')}</strong>
                        </div>

                        {/* Heures */}
                        <div className="d-flex align-items-center gap-2">
                          <Form.Control
                            type="time"
                            size="sm"
                            style={{ width: '100px' }}
                            value={dateObj.heure_deb}
                            onChange={(e) => handleTimeChange(dateObj.date, 'heure_deb', e.target.value)}
                          />
                          {/* <span>à</span> */}
                          <Form.Control
                            type="time"
                            size="sm"
                            style={{ width: '100px' }}
                            value={dateObj.heure_fin}
                            onChange={(e) => handleTimeChange(dateObj.date, 'heure_fin', e.target.value)}
                          />
                        </div>
                      </div>

                      {/* Bouton supprimer */}
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => handleRemoveDate(dateObj.date)}
                        className="d-flex align-items-center"
                      >
                        <FaTimes />
                      </Button>
                    </div>
                  );
                })}
              </div>
            ) : (
              <Alert variant="warning" className="mb-0 d-flex align-items-center">
                <FaExclamationTriangle className="mr-2" />
                Aucune date sélectionnée. Ajoutez des dates via le champs "Nouvelle date".
              </Alert>
            )}
          </div>
        </Form.Group>
      </div>
    );
  };

  const renderCalendar = () => {
    return (
      <div className="calendar-container p-3">
        <CustomCalendar
          events={calendarEvents}
          onDateClick={handleDateClick}
          onEventClick={handleEventClick}
          initialView={calendarView}
          height="600px"
        />
      </div>
    );
  };



  // Ajoutez ces états avec les autres états
  const [showReservationsModal, setShowReservationsModal] = useState(false);
  const [currentBookingReservations, setCurrentBookingReservations] = useState([]);
  const [selectedBookingForReservations, setSelectedBookingForReservations] = useState(null);

  // Ajoutez cette fonction pour gérer l'ouverture du modal des réservations
  const handleShowReservationsModal = (booking) => {
    setSelectedBookingForReservations(booking);

    // Utiliser directement les réservations du booking
    const bookingReservations = booking.reservations || [];
    setCurrentBookingReservations(bookingReservations);
    setShowReservationsModal(true);
  };

  // Fonction pour changer le statut d'une réservation depuis le modal
  const handleChangeReservationStatusInModal = async (reservationId, newStatus, motif = '') => {
    try {
      setIsChargement(true);

      const requestBody = {
        reservation_id: reservationId,
        statut: newStatus,
        user_id: user_id
      };

      if (newStatus === 3 && motif) {
        requestBody.motif_annulation = motif;
      }

      const response = await fetch(`${process.env.REACT_APP_HOTE}/modifier-statut-reservation/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Erreur lors de la modification du statut');
      }

      if (data.status === 'success') {
        // Mettre à jour la liste locale
        setCurrentBookingReservations(prevReservations =>
          prevReservations.map(reservation =>
            reservation.id === reservationId
              ? {
                ...reservation,
                statut: newStatus,
                ...(newStatus === 3 && motif && { motif_annulation: motif })
              }
              : reservation
          )
        );

        showAlert(data.message, 'success');
      } else {
        throw new Error(data.message || 'Erreur lors de la modification du statut');
      }

    } catch (error) {
      console.error('Erreur lors de la modification du statut:', error);
      showAlert(`Erreur: ${error.message}`, 'danger');
    } finally {
      setIsChargement(false);
    }
  };


  const handleChangerStatut = async () => {
    try {
      setIsChargement(true);

      const response = await fetch(`${process.env.REACT_APP_HOTE}/changer-statut-booking/${selectedBooking.id}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: user_id
        }),
      });

      const data = await response.json();

      if (data.status === 'success') {
        handleCloseStatutModal()
        showAlert(data.message, 'success');
        fetchBookings();
      } else {
        showAlertModal(data.message || 'Erreur lors du changement de statut', 'danger');
      }

    } catch (error) {
      console.error('Erreur:', error);
      showAlertModal(`Erreur: ${error.message}`, 'danger');
    } finally {
      setIsChargement(false);
    }
  };


  const [teamsLink, setTeamsLink] = useState('');
  const [isLoadingTeams, setIsLoadingTeams] = useState(false);

  const handleSaveTeamsLink = async () => {
    try {
      setIsLoadingTeams(true);
      const response = await fetch(`${process.env.REACT_APP_HOTE}/enregistrer-lien-teams/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          lien_teams: teamsLink
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Erreur lors de la sauvegarde');
      }

      if (data.status === 'success') {
        showAlert(data.message, 'success');
      } else {
        throw new Error(data.message || 'Erreur lors de la sauvegarde');
      }

    } catch (error) {
      console.error('Erreur:', error);
      showAlert(`Erreur lors de la sauvegarde: ${error.message}`, 'danger');
    } finally {
      setIsLoadingTeams(false);
    }
  };

  useEffect(() => {
    const fetchTeamsLink = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-lien-teams/`);

        if (!response.ok) {
          throw new Error('Erreur lors de la récupération du lien Teams');
        }

        const data = await response.json();

        if (data.status === 'success') {
          setTeamsLink(data.lien_teams || '');
        } else {
          throw new Error(data.message || 'Erreur lors de la récupération');
        }

      } catch (error) {
        console.error('Erreur lors du chargement du lien Teams:', error);
      }
    };

    fetchTeamsLink();
  }, []);

  const renderTeamsConfig = () => (
    <div className="teams-config-container">
      <Card className="border-0 shadow-sm">
        <Card.Body className="p-4">
          <Form>
            <Form.Group className="mb-4">
              <Form.Label>
                <strong>Lien de réunion Microsoft Teams</strong>
              </Form.Label>
              <Form.Control
                type="url"
                placeholder="https://teams.microsoft.com/l/meetup-join/..."
                value={teamsLink}
                onChange={(e) => setTeamsLink(e.target.value)}
                style={{ fontSize: '14px' }}
              />
            </Form.Group>

            <div className="d-flex gap-2">
              <Button
                variant="success"
                onClick={handleSaveTeamsLink}
                disabled={isLoadingTeams}
                className="d-flex align-items-center"
              >
                {isLoadingTeams ? (
                  <>
                    <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                    Sauvegarde...
                  </>
                ) : (
                  <>
                    <FaCheck />
                    <span className="d-none d-sm-inline ml-1">
                      Sauvegarder le lien
                    </span>
                  </>
                )}
              </Button>

              {teamsLink && (
                <Button
                  variant="outline-success"
                  href={teamsLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-flex align-items-center ml-2"
                >
                  <FaVideo className="me-2" />
                  <span className="d-none d-sm-inline ml-1">
                    Tester le lien
                  </span>
                </Button>
              )}
            </div>
          </Form>

          {teamsLink && (
            <div className="mt-4 p-3 bg-light rounded">
              <h6 className="mb-2">Lien actuel :</h6>
              <code className="text-break" style={{ fontSize: '12px' }}>
                {teamsLink}
              </code>
            </div>
          )}
        </Card.Body>
      </Card>

      <Card className="border-0 shadow-sm mt-4">
        <Card.Header className="bg-white border-0">
          <h6 className="mb-0 text-dark">Instructions</h6>
        </Card.Header>
        <Card.Body className="p-4">
          <div className="row">
            <div className="col-md-6">
              <h6>Comment obtenir votre lien Teams :</h6>
              <ol className="small text-muted">
                <li>Ouvrez Microsoft Teams</li>
                <li>Créez une nouvelle réunion</li>
                <li>Cliquez sur "Obtenir le lien de participation"</li>
                <li>Copiez le lien et collez-le ci-dessus</li>
              </ol>
            </div>
            <div className="col-md-6">
              <h6>Fonctionnalités :</h6>
              <ul className="small text-muted">
                <li>Lien utilisé pour toutes les bookings en ligne</li>
                <li>Modifiable à tout moment</li>
                <li>Testable directement depuis cette page</li>
              </ul>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );

  useEffect(() => {
    if (activeTab === 'reservations' && selectedBooking) {
      fetchReservations(selectedBooking.id);
    }
  }, [activeTab, selectedBooking]);

  const renderDashboard = () => {
    if (isLoadingListeBooking) {
      return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
          <div className="spiner-example">
            <div className="sk-spinner sk-spinner-wave">
              <div className="sk-rect1 mr-1"></div>
              <div className="sk-rect2 mr-1"></div>
              <div className="sk-rect3 mr-1"></div>
              <div className="sk-rect4 mr-1"></div>
              <div className="sk-rect5"></div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="dashboard-view">
        <Row>
          <Col lg={12}>
            <Card className="h-100 border-0 shadow-lg">
              <Card.Header className="bg-white border-0">
                <div className="d-flex border-bottom">
                  <button
                    className={`btn btn-tab d-flex justify-content-center align-items-center ${activeTab === 'calendrier' ? 'active' : ''}`}
                    onClick={() => setActiveTab('calendrier')}
                  >
                    <FaCalendarAlt className="mr-1" />
                    Calendrier
                  </button>
                  <button
                    className={`btn btn-tab d-flex justify-content-center align-items-center ${activeTab === 'bookings' ? 'active' : ''}`}
                    onClick={() => setActiveTab('bookings')}
                  >
                    <FaList className="mr-1" />
                    Liste des bookings
                  </button>
                  <button
                    className={`btn btn-tab d-flex justify-content-center align-items-center ${activeTab === 'reservations' ? 'active' : ''}`}
                    onClick={() => {
                      setActiveTab('reservations');
                      if (selectedBooking) {
                        fetchReservations(selectedBooking.id);
                      }
                    }}
                  >
                    <FaStar className="mr-1" />
                    Réservations
                  </button>
                  <button
                    className={`btn btn-tab d-flex justify-content-center align-items-center ${activeTab === 'teams' ? 'active' : ''}`}
                    onClick={() => setActiveTab('teams')}
                  >
                    <FaVideo className="mr-1" />
                    Configuration Teams
                  </button>
                </div>

                <div className="mt-3 d-flex justify-content-end gap-2">
                  <Button
                    variant="outline-success"
                    size="sm"
                    onClick={() => setShowExportModal(true)}
                    className="d-flex align-items-center mr-2"
                  >
                    <FaFileExcel className="me-1" />
                    <span className="d-none d-sm-inline">
                      Exporter bilan
                    </span>
                  </Button>
                  <Button
                    variant="success"
                    size="sm"
                    onClick={() => handleBookingModalOpen()}
                  >
                    <FaPlus className="me-1" />
                    <span className="d-none d-sm-inline">
                      Ajouter booking
                    </span>
                  </Button>
                </div>
              </Card.Header>

              <Card.Body className="pl-4 pr-4 pb-4 pt-0 d-flex flex-column">
                {activeTab === 'calendrier' ? (
                  <>
                    {renderCalendar()}
                  </>
                ) : activeTab === 'bookings' ? (
                  renderBookingsList()
                ) : activeTab === 'reservations' ? (
                  renderReservations()
                ) : (
                  renderTeamsConfig()
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <div id="wrapper">
      <Sidebar user_id={user_id} />
      <div id="page-wrapper" className="gray-bg">
        <Navbar />
        <div className="gestion-rendez-vous-coach">
          <div className="row wrapper border-bottom white-bg page-heading">
            <div className="col-lg-12">
              <h2 className="d-flex align-items-center text-primary">
                <FaCalendarAlt size={25} className="mr-2" />
                Booking
              </h2>
              <p className="text-muted">Créez et gérez vos booking</p>

              <small id='hbreadcrumb' className='d-flex justify-content-end'>
                <ol className="breadcrumb custom-breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={`/admin`}>Administration</Link>
                  </li>
                  <li className="breadcrumb-item">
                    Booking
                  </li>
                </ol>
              </small>
            </div>
          </div>

          {alert.message && (
            <div className={`alert alert-${alert.type} row justify-content-between position-relative m-2 mt-2`}>
              <div dangerouslySetInnerHTML={{ __html: alert.message }} />
              <span
                onClick={fermerNotif}
                style={{
                  position: 'absolute',
                  top: '0px',
                  right: '10px',
                  cursor: 'pointer'
                }}
              >
                <i className='fa fa-close'></i>
              </span>
            </div>
          )}

          <div className="wrapper wrapper-content animated fadeInRight m-0">
            <div className="row">
              <div className="col-lg-12">
                {renderDashboard()}
              </div>
            </div>
          </div>
        </div>

        {/* Modal pour ajouter/modifier un booking */}
        <Modal show={showBookingModal} onHide={() => setShowBookingModal(false)} centered size="lg">
          <Modal.Header className="">
            <Modal.Title>
              {nouveauBooking?.id ? 'Modifier le booking' : 'Nouveau booking'}
            </Modal.Title>
          </Modal.Header>

          {alertModal.message && (
            <div className={`m-3 alert alert-${alertModal.type}`}>
              {alertModal.message}
              <span
                onClick={fermerNotif}
                style={{
                  position: 'absolute',
                  top: '0px',
                  right: '10px',
                  cursor: 'pointer'
                }}
              >
                <i className='fa fa-close'></i>
              </span>
            </div>
          )}

          <Modal.Body className="p-4">
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Titre du booking <span className='text-danger'>*</span></Form.Label>
                <Form.Control
                  type="text"
                  value={nouveauBooking?.titre}
                  onChange={(e) => setNouveauBooking({ ...nouveauBooking, titre: e.target.value })}
                  placeholder="Ex: Coaching PMP"
                  required
                />
              </Form.Group>



              {/* Solution ultra simple */}
              <Card className="mb-3">
                <Card.Body className="p-2">
                  <div className="">
                    {/* Gestionnaire de dates multiples */}
                    {renderDateManager()}
                    <Form.Group className="flex-grow-1">
                      <Form.Label className="small mb-1">Nouvelle date</Form.Label>
                      <Form.Control
                        type="date"
                        size="sm"
                        // min={moment().format('YYYY-MM-DD')}
                        onKeyDown={(e) => {
                          // Autoriser les touches de navigation et suppression
                          if (
                            e.key === 'Backspace' ||
                            e.key === 'Delete' ||
                            e.key === 'Tab' ||
                            e.key === 'ArrowLeft' ||
                            e.key === 'ArrowRight' ||
                            e.key === 'ArrowUp' ||
                            e.key === 'ArrowDown' ||
                            e.key === 'Home' ||
                            e.key === 'End' ||
                            e.key === 'Enter'
                          ) {
                            return;
                          }

                          // Autoriser les chiffres, le slash et le tiret
                          if (!/^[0-9\/\-]$/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          if (e.target.value) {
                            handleAddDate(e.target.value);
                            e.target.value = ''; // Reset après sélection
                          }
                        }}
                        // Optionnel : ajouter un placeholder personnalisé
                        style={{
                          colorScheme: 'light', // Pour un meilleur contraste
                        }}
                      />
                    </Form.Group>
                  </div>
                  {/* <Form.Text className="text-muted small">
                    Cliquez sur "Aujourd'hui" ou sélectionnez une date future
                  </Form.Text> */}
                </Card.Body>
              </Card>

              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Type <span className='text-danger'>*</span></Form.Label>
                    <Form.Select
                      className='custom-select'
                      value={nouveauBooking?.type_booking}
                      onChange={(e) => setNouveauBooking({ ...nouveauBooking, type_booking: e.target.value })}
                      required
                    >
                      <option value="">Sélectionnez un type</option>
                      <option value="Coaching">Coaching</option>
                      <option value="Conseil">Conseil</option>
                      <option value="Formation">Formation</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              {/* <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Heure de début <span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                      type="time"
                      value={nouveauBooking?.heure_deb || '09:00'}
                      onChange={(e) => setNouveauBooking({
                        ...nouveauBooking,
                        heure_deb: e.target.value
                      })}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Heure de fin <span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                      type="time"
                      value={nouveauBooking?.heure_fin || '10:00'}
                      onChange={(e) => setNouveauBooking({
                        ...nouveauBooking,
                        heure_fin: e.target.value
                      })}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row> */}

              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={nouveauBooking?.description}
                  onChange={(e) => setNouveauBooking({ ...nouveauBooking, description: e.target.value })}
                  placeholder="Description détaillée du booking..."
                  required
                />
              </Form.Group>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Format <span className='text-danger'>*</span></Form.Label>
                    <Form.Select
                      className='custom-select'
                      value={nouveauBooking.type_crenau}
                      onChange={(e) => setNouveauBooking({ ...nouveauBooking, type_crenau: e.target.value })}
                      required
                    >
                      <option value="en_ligne">Virtuel</option>
                      <option value="presentiel">Présentiel</option>
                      <option value="deux">Les deux</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Nombre de places <span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                      type="number"
                      value={nouveauBooking.nb_participants}
                      onChange={(e) => setNouveauBooking({ ...nouveauBooking, nb_participants: parseInt(e.target.value) })}
                      min="1"
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Couleur <span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                      type="color"
                      value={nouveauBooking?.couleur}
                      onChange={(e) => setNouveauBooking({ ...nouveauBooking, couleur: e.target.value })}
                    />
                  </Form.Group>
                </Col>
              </Row> */}

              {/* CHAMP LIEU - Conditionnel pour présentiel ou les deux */}
              {(nouveauBooking.type_crenau === 'presentiel' || nouveauBooking.type_crenau === 'deux') && (
                <Form.Group className="mb-3">
                  <Form.Label>
                    Lieu <span className='text-danger'>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={nouveauBooking.lieu}
                    onChange={(e) => setNouveauBooking({ ...nouveauBooking, lieu: e.target.value })}
                    placeholder="Ex: Calavi-Zogbadje, Bénin"
                    required={nouveauBooking.type_crenau === 'presentiel' || nouveauBooking.type_crenau === 'deux'}
                  />
                  <Form.Text className="text-muted">
                    Adresse complète du lieu de rendez-vous pour les sessions présentielles
                  </Form.Text>
                </Form.Group>
              )}

              {(nouveauBooking.type_crenau === 'en_ligne' || nouveauBooking.type_crenau === 'deux') && (
                <Form.Group className="mb-3">
                  <Form.Label>
                    Lien Teams pour ce booking <span className='text-danger'>*</span>
                  </Form.Label>
                  <div className="d-flex gap-2">
                    <Form.Control
                      type="url"
                      value={nouveauBooking.lien_teams}
                      onChange={(e) => setNouveauBooking({ ...nouveauBooking, lien_teams: e.target.value })}
                      placeholder="https://teams.microsoft.com/l/meetup-join/..."
                    />
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={() => setNouveauBooking({ ...nouveauBooking, lien_teams: teamsLink })}
                      title="Utiliser le lien Teams préconfiguré"
                    >
                      <FaLink className="me-1" />
                      {/* Lien global */}
                    </Button>
                  </div>
                  <Form.Text className="text-muted" style={{ fontSize: '0.8rem', fontStyle: 'italic' }}>
                    {/* Lien Teams global configuré : <code style={{ fontSize: '0.75rem' }}>{teamsLink}</code>
                    <br /> */}
                    Utilisez le lien préconfiguré, ou saisissez un lien spécifique pour ce booking.
                  </Form.Text>
                </Form.Group>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowBookingModal(false)}>
              Annuler
            </Button>
            {isChargement ? (
              <Button variant="success" disabled>
                <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                {nouveauBooking?.id ? 'Modification...' : 'Création...'}
              </Button>
            ) : (
              <Button variant="success" onClick={handleSaveBooking}>
                {nouveauBooking?.id ? 'Modifier' : 'Créer le booking'}
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        {/* Modal de confirmation de suppression */}
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
          <Modal.Header className="">
            <Modal.Title>
              Confirmation de suppression
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <div className="text-left">
              <h5>Êtes-vous sûr de vouloir supprimer le booking <strong>{bookingToDelete?.title}</strong> ?</h5>
              <p className="text-muted mt-3 mb-0">
                Cette action est irréversible.
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowDeleteModal(false);
                setBookingToDelete(null);
              }}
              disabled={isChargement}
            >
              Annuler
            </Button>
            {isChargement ? (
              <Button variant="success" disabled>
                <div className="spinner-border spinner-border-sm me-2" role="status">
                </div>
                Suppression...
              </Button>
            ) : (
              <Button
                variant="success"
                className='d-flex justify-content-center align-items-center'
                onClick={handleDeleteBooking}
              >
                <FaTrash className="mr-1" />
                Supprimer définitivement
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        {/* Modal de confirmation pour confirmer une réservation */}
        <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
          <Modal.Header className="">
            <Modal.Title>
              Confirmer la réservation
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <div className="text-left">
              <h5>Confirmer cette réservation ?</h5>
              <p className="text-muted">
                Êtes-vous sûr de vouloir confirmer la réservation de{" "}
                <strong>{selectedReservation?.prenom} {selectedReservation?.nom}</strong> ?
              </p>
              <div className="bg-light p-3 rounded mt-3">
                <div className="row text-start">
                  <div className="col-6">
                    <strong>Booking :</strong><br />
                    {selectedReservation?.booking_title}
                  </div>
                  <div className="col-6">
                    <strong>Créneau :</strong><br />
                    <span>{selectedReservation && moment(selectedReservation.date).format('DD/MM/YYYY')} de </span>
                    <span>{selectedReservation?.heure_deb} à {selectedReservation?.heure_fin}</span>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowConfirmModal(false)} disabled={isChargement}>
              Annuler
            </Button>
            <Button variant="success" onClick={handleConfirmAction} disabled={isChargement}>
              {isChargement ? (
                <>
                  <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                  Confirmation...
                </>
              ) : (
                <>
                  <FaCheck className="me-1" />
                  Confirmer la réservation
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de confirmation pour annuler une réservation */}
        <Modal show={showCancelModal} onHide={() => {
          setShowCancelModal(false);
          setAnnulationMotif('');
        }} centered>
          <Modal.Header className="">
            <Modal.Title>
              Annuler la réservation
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <div>
              <h5>Annuler cette réservation ?</h5>
              <p className="text-muted">
                Êtes-vous sûr de vouloir annuler la réservation de{" "}
                <strong>{selectedReservation?.prenom} {selectedReservation?.nom}</strong> ?
              </p>

              <Form.Group className="mb-3">
                <Form.Label>
                  <strong>Motif d'annulation <span className='text-danger'>*</span></strong>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={annulationMotif}
                  onChange={(e) => setAnnulationMotif(e.target.value)}
                  placeholder="Veuillez saisir le motif de l'annulation..."
                  required
                />
              </Form.Group>

              {selectedReservation && !canCancelReservation(selectedReservation) && (
                <Alert variant="danger" className="mt-3">
                  <FaExclamationTriangle className="me-2" />
                  <strong>Attention :</strong> Cette réservation commence bientôt. L'annulation n'est plus possible.
                </Alert>
              )}

              <div className="bg-light p-3 rounded mt-3">
                <div className="row text-start">
                  <div className="col-6">
                    <strong>Booking :</strong><br />
                    {selectedReservation?.booking_title}
                  </div>
                  <div className="col-6">
                    <strong>Créneau :</strong><br />
                    <span>{selectedReservation && moment(selectedReservation.date).format('DD/MM/YYYY')} de </span>
                    <span>{selectedReservation?.heure_deb} à {selectedReservation?.heure_fin}</span>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseCancelModal} disabled={isChargement}>
              Garder la réservation
            </Button>
            <Button
              variant="success"
              onClick={handleCancelAction}
              disabled={isChargement || (selectedReservation && !canCancelReservation(selectedReservation)) || !annulationMotif.trim()}
            >
              {isChargement ? (
                <>
                  <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                  Annulation...
                </>
              ) : (
                <>
                  <FaTimes className="me-1" />
                  Annuler la réservation
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>







        <Modal show={showReservationsModal} onHide={() => setShowReservationsModal(false)} size="lg" centered>
          <Modal.Header className="">
            <Modal.Title>
              {/* <FaUser className="mr-2" /> */}
              Réservations - {selectedBookingForReservations?.title}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="p-4">
            {currentBookingReservations.length > 0 ? (
              <div className="">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <h6 className="mb-1">Total: {currentBookingReservations.length} réservation{currentBookingReservations.length !== 1 ? 's' : ''}</h6>
                    <p className="text-muted mb-0 small">
                      Booking : {selectedBookingForReservations?.type} • {selectedBookingForReservations?.nb_participants} places
                    </p>
                  </div>
                  <Badge bg="info" className="fs-6">
                    {moment(selectedBookingForReservations?.date_booking).format('DD/MM/YYYY')}
                  </Badge>
                </div>

                <table className="footable table table-stripped footable-loaded tablet breakpoint">
                  <thead>
                    <tr>
                      <th>Client</th>
                      <th>Contact</th>
                      <th>Statut</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentBookingReservations.map((reservation) => (
                      <tr key={reservation.id}>
                        <td>
                          <div className="fw-bold">
                            {reservation.prenom} {reservation.nom}
                          </div>
                          <small className="text-muted">
                            Réservé le {moment(reservation.date_creation).format('DD/MM/YYYY à HH:mm')}
                          </small>
                        </td>
                        <td>
                          <div className="small">
                            <div>
                              <FaUser size={12} className="mr-1 text-muted" />
                              {reservation.email}
                            </div>
                            <div className="mt-1">
                              <FaPhone size={12} className="mr-1 text-muted" />
                              {reservation.telephone || 'Non renseigné'}
                            </div>
                          </div>
                        </td>
                        <td>
                          <Badge
                            bg={
                              reservation.statut === '1' ? 'warning' :
                                reservation.statut === '2' ? 'success' :
                                  'danger'
                            }
                            className="fs-6"
                          >
                            {reservation.statut === '1' && 'En attente'}
                            {reservation.statut === '2' && 'Confirmée'}
                            {reservation.statut === '3' && 'Annulée'}
                          </Badge>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-4">
                <FaUser size={50} className="text-muted mb-3" />
                <h5 className="text-muted">Aucune réservation</h5>
                <p className="text-muted">
                  Aucune réservation n'a été faite pour ce booking pour le moment.
                </p>
              </div>
            )}
          </Modal.Body>

          <Modal.Footer className="d-flex justify-content-end">
            <Button variant="secondary" onClick={() => setShowReservationsModal(false)}>
              Fermer
            </Button>
          </Modal.Footer>
        </Modal>


        {/* Modal de détails du booking */}
        <Modal
          show={showDetailsModal}
          onHide={() => setShowDetailsModal(false)}
          size="lg"
          centered
          contentClassName="border-0 shadow-lg"
        >
          {/* HEADER */}
          <Modal.Header className=" py-3">
            <Modal.Title className="fs-5 d-flex align-items-center">
              <FaInfoCircle className="mr-2" />
              <span>Détails du booking</span>
            </Modal.Title>
          </Modal.Header>

          {/* BODY */}
          <Modal.Body className="p-3">
            {selectedBookingDetails && (
              <div className="booking-details">

                {/* TITRE + TYPE */}
                <div className="text-center mb-3">
                  <h5 className="text-dark mb-2 fw-bold">{selectedBookingDetails.title}</h5>
                  <div
                    className="px-3 py-1 rounded-pill text-white fw-medium d-inline-block shadow-sm"
                    style={{
                      backgroundColor: selectedBookingDetails.color || '#0d6efd',
                      fontSize: '0.8rem',
                      border: `2px solid ${selectedBookingDetails.color || '#0d6efd'}25`
                    }}
                  >
                    {selectedBookingDetails.type}
                  </div>
                </div>

                {/* LIGNE DESCRIPTION + INFOS */}
                <Row className="g-3">
                  {/* Description */}
                  {selectedBookingDetails.description && (
                    <Col md={6}>
                      <div className="bg-light rounded p-3 h-100">
                        <h6 className="text-primary mb-2 fw-semibold small">
                          <FaInfoCircle className="mr-1" size={12} />
                          Description
                        </h6>
                        <p className="mb-0 text-dark small" style={{ lineHeight: '1.4' }}>
                          {selectedBookingDetails.description}
                        </p>
                      </div>
                    </Col>
                  )}

                  {/* Informations principales */}
                  <Col md={selectedBookingDetails.description ? 6 : 12}>
                    <div className="bg-light rounded p-3 h-100">
                      <h6 className="text-primary mb-2 fw-semibold small">
                        <FaCalendarAlt className="mr-1" size={12} />
                        Informations
                      </h6>
                      <div className="small text-dark">
                        <div className="d-flex justify-content-between border-bottom pb-1 mb-2">
                          <span className="text-muted">Date :</span>
                          <strong>{moment(selectedBookingDetails.date_booking).format('DD/MM/YYYY')}</strong>
                        </div>
                        <div className="d-flex justify-content-between border-bottom pb-1 mb-2">
                          <span className="text-muted">Horaire :</span>
                          <strong>{selectedBookingDetails.heure_deb} - {selectedBookingDetails.heure_fin}</strong>
                        </div>
                        <div className="d-flex justify-content-between border-bottom pb-1 mb-2">
                          <span className="text-muted">Format :</span>
                          <span
                            className="px-2 py-1 rounded text-white fw-medium bg-success"
                            style={{
                              fontSize: '0.7rem',
                              // backgroundColor: selectedBookingDetails.type_crenau === 'en_ligne' ? '#198754' : '#fd7e14'
                            }}
                          >
                            {selectedBookingDetails.type_crenau === 'en_ligne' ? 'Virtuel' : 'Présentiel'}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Places réservés :</span>
                          <strong>{selectedBookingDetails?.reservations?.length}</strong>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>

                {/* LIGNE LOCALISATION / LIEN + DATES MULTIPLES */}
                <Row className="g-3 mt-2">
                  {/* Localisation */}
                  <Col md={6}>
                    {(selectedBookingDetails.lieu || selectedBookingDetails.lien_teams) && (
                      <div className="bg-light rounded p-3 h-100">
                        <h6 className="text-primary mb-2 fw-semibold small">
                          <FaMapMarkerAlt className="mr-1" size={12} />
                          Localisation
                        </h6>
                        {selectedBookingDetails.type_crenau === 'presentiel' && selectedBookingDetails.lieu && (
                          <div className="small text-dark">
                            <div className="d-flex align-items-start">
                              <span>{selectedBookingDetails.lieu}</span>
                            </div>
                          </div>
                        )}
                        {selectedBookingDetails.type_crenau === 'en_ligne' && selectedBookingDetails.lien_teams && (
                          <div className="small">
                            <div className="d-flex align-items-center">
                              <FaVideo className="text-primary mr-2" size={12} />
                              <a
                                href={selectedBookingDetails.lien_teams}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-primary text-decoration-none fw-medium"
                              >
                                Rejoindre la réunion
                              </a>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </Col>

                  {/* Dates multiples */}
                  <Col md={6}>
                    {selectedBookingDetails.dates_booking?.length > 1 && (
                      <div className="bg-light rounded p-3 h-100">
                        <h6 className="text-primary mb-2 fw-semibold small">
                          <FaCalendarDay className="mr-1" size={12} />
                          Sessions ({selectedBookingDetails.dates_booking.length})
                        </h6>
                        <div className="small text-dark" style={{ maxHeight: '120px', overflowY: 'auto' }}>
                          {selectedBookingDetails.dates_booking.map((d, i) => (
                            <div key={i} className="d-flex justify-content-between border-bottom pb-1 mb-1">
                              <span>{moment(d.date).format('DD/MM')}</span>
                              <span className="text-muted">
                                {d.heure_deb && `${d.heure_deb}-${d.heure_fin}`}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>

          {/* FOOTER */}
          <Modal.Footer className="py-3 bg-light border-top">
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => setShowDetailsModal(false)}
              className="px-3"
            >
              Fermer
            </Button>
            <Button
              variant="success"
              size="sm"
              onClick={() => {
                setShowDetailsModal(false);
                handleBookingModalOpen(selectedBookingDetails);
              }}
              className="px-3 d-flex align-items-center"
            >
              <FaEdit className="me-2" size={12} />
              Modifier
            </Button>
          </Modal.Footer>
        </Modal>



        {/* Modal d'assignation de coach */}
        <Modal show={showAssignCoachModal} onHide={handleCloseAssignCoachModal} size="lg" centered>
          <Modal.Header className="">
            <Modal.Title className="d-flex align-items-center">
              Assigner un coach - {selectedBookingForCoach?.title}
            </Modal.Title>
          </Modal.Header>

          {alertModal.message && (
            <div className={`m-3 alert alert-${alertModal.type}`}>
              {alertModal.message}
              <span
                onClick={fermerNotif}
                style={{
                  position: 'absolute',
                  top: '0px',
                  right: '10px',
                  cursor: 'pointer'
                }}
              >
                <i className='fa fa-close'></i>
              </span>
            </div>
          )}

          <Modal.Body className="p-4">
            <div className="mb-4">
              <Form.Group>
                <Form.Label>Rechercher un utilisateur</Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type="text"
                    placeholder="Rechercher par nom, prénom ou email..."
                    value={searchUserTerm}
                    onChange={(e) => handleSearchUsers(e.target.value)}
                  />
                  <FaSearch
                    className="position-absolute text-muted"
                    style={{ right: '12px', top: '50%', transform: 'translateY(-50%)' }}
                  />
                </div>
              </Form.Group>
            </div>

            {isLoadingUsers ? (
              <div className="text-center py-4">
                <div className="spiner-example">
                  <div className="sk-spinner sk-spinner-wave">
                    <div className="sk-rect1 mr-1"></div>
                    <div className="sk-rect2 mr-1"></div>
                    <div className="sk-rect3 mr-1"></div>
                    <div className="sk-rect4 mr-1"></div>
                    <div className="sk-rect5"></div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="users-list" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                {filteredUsers.length > 0 ? (
                  <table className="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>Nom & Prénom</th>
                        <th>Email</th>
                        <th>Téléphone</th>
                        <th className="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredUsers.map((utilisateur) => (
                        <tr key={utilisateur.id}>
                          <td>
                            <div className="fw-bold">
                              {utilisateur.prenoms} {utilisateur.nom}
                            </div>
                          </td>
                          <td>
                            <small className="text-muted">{utilisateur.email}</small>
                          </td>
                          <td>
                            <small>{utilisateur.tel || 'Non renseigné'}</small>
                          </td>
                          <td className="text-center">
                            <button
                              size="sm"
                              onClick={() => handleAssignCoach(utilisateur)}
                              disabled={loadingAssignId !== null} // Désactiver tous les boutons pendant un chargement OU désactiver seulement celui en cours
                              className="btn btn-success d-flex align-items-center justify-content-center mx-auto"
                              style={{ minWidth: '100px' }}
                            >
                              {loadingAssignId === utilisateur.id ? (
                                <>
                                  <div className="spinner-border spinner-border-sm mr-2" role="status"></div>
                                  Assigner
                                </>
                              ) : (
                                <>
                                  Assigner
                                  <FaArrowRight className="ml-1" />
                                </>
                              )}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="text-center py-4">
                    <h5 className="text-muted">Aucun utilisateur trouvé</h5>
                    <p className="text-muted">
                      {searchUserTerm
                        ? 'Aucun utilisateur ne correspond à votre recherche.'
                        : 'Aucun utilisateur disponible.'
                      }
                    </p>
                    {/* {searchUserTerm && (
                      <Button
                        variant="outline-secondary"
                        onClick={() => setSearchUserTerm('')}
                      >
                        <FaTimes className="me-1" />
                        Effacer la recherche
                      </Button>
                    )} */}
                  </div>
                )}
              </div>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseAssignCoachModal}>
              Fermer
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showStatutModal} onHide={handleCloseStatutModal} centered>
          <Modal.Header>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="text-center">
              <h5>Êtes-vous sûr de vouloir changer le statut de ce booking ?</h5>
              <p className="text-muted">
                Le booking "{selectedBooking?.title}" sera marqué comme{" "}
                {selectedBooking?.statut === "1" ? "terminé" : "en attente"}.
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={handleCloseStatutModal}
              disabled={isChargement}
            >
              Annuler
            </Button>
            <Button
              variant="success"
              onClick={handleChangerStatut}
              disabled={isChargement}
            >
              {isChargement ? (
                <>
                  <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                  Traitement...
                </>
              ) : (
                "Confirmer"
              )}
            </Button>
          </Modal.Footer>
        </Modal>


        {/*ceci c'est le modalexport du bilan coaching */}
        <Modal show={showExportModal} onHide={() => setShowExportModal(false)} centered>
          <Modal.Header>
            <Modal.Title>
              {/* <FaFileExcel className="me-2" /> */}
              Exporter le bilan coaching
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Sélectionnez le mois <span className="text-danger">*</span></Form.Label>
                <Form.Select
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                  required
                  className='custom-select'
                >
                  <option value="">Choisissez un mois</option>
                  <option value="tous">Tous les mois</option>
                  {Array.from({ length: 12 }, (_, i) => {
                    const date = moment().subtract(i, 'months');
                    return (
                      <option key={i} value={date.format('YYYY-MM')}>
                        {date.format('MMMM YYYY')}
                      </option>
                    );
                  })}
                </Form.Select>
                <Form.Text className="text-muted">
                  Le fichier Excel contiendra tous les coaching terminés (statut "Terminé") pour le mois sélectionné.
                </Form.Text>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowExportModal(false)}
              disabled={isExporting}
            >
              Annuler
            </Button>
            <Button
              variant="success"
              onClick={handleExportBilan}
              disabled={isExporting || !selectedMonth}
              className="d-flex align-items-center"
            >
              {isExporting ? (
                <>
                  <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                  Export en cours...
                </>
              ) : (
                <>
                  <FaFileExcel className="me-2" />
                  Exporter
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        <style>{`
          .calendar-container {
            background: white;
            border-radius: 12px;
            padding: 0;
            overflow: hidden;
            border: 1px solid #e5e7eb;
          }

          .btn-tab {
            border: none;
            border-bottom: 3px solid transparent;
            border-radius: 0;
            padding: 10px 20px;
            color: #6c757d;
            background: transparent;
            transition: all 0.3s ease;
          }

          .btn-tab.active {
            color: #0d6efd;
            border-bottom-color: #0d6efd;
            background-color: rgba(13, 110, 253, 0.05);
          }

          .btn-tab:hover {
            color: #0d6efd;
            background-color: rgba(13, 110, 253, 0.05);
          }

          .btn {
            border-radius: 8px;
            font-weight: 500;
            transition: all 0.2s ease;
          }

          .card {
            border-radius: 12px;
            overflow: hidden;
            background: white;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
          }

          .badge {
            border-radius: 12px;
            font-weight: 500;
          }

          .user-info {
            text-align: left;
          }

          .res-info {
            text-align: right;
          }

          .cursor-pointer {
            cursor: pointer;
          }

          @media (max-width: 576px) {
            .user-info,
            .res-info {
              text-align: left;
            }
          }
        `}</style>
      </div>
    </div>
  );
};

export default GestionRendezVousAdmin;